import packageJSON from '../../package.json';
import { Environment } from './index';
import {
  STAGING_API_URL,
  STAGING_AUTH_API_URL,
  STAGING_CLIENT_ID,
  TEST_AUTH_URL,
  WOD_EMPLOYEES_URL,
} from './constants';

export default {
  CLIENT_ID: STAGING_CLIENT_ID,
  API_URL: STAGING_API_URL,
  AUTH_URL: STAGING_AUTH_API_URL,
  WOD_URL: WOD_EMPLOYEES_URL,
  VERSION: `staging-cy-${packageJSON.version}`,
  TEST_AUTH_URL: TEST_AUTH_URL,
  featureFlags: {},
} as Environment;
